module.exports = __webpack_public_path__ + "img/thomas-gray.4aa66cc9.png";